module.exports = __webpack_public_path__ + "img/5.66dc1479.svg";